'use strict';

module.exports = function ($uibModal, $state, $scope, departments, dialog, Department, myTenant, toast, gridConfiguration, $translate) {
    var _this = this;

    this.department = departments.filter(function (department) {
        return department.id === $state.params.departmentId;
    })[0];
    this.selectedMembers = [];

    this.importMode = $state.params.mode;

    this.page1 = true;
    this.page2 = false;
    this.page3 = false;

    _this.myTenant = myTenant;
    this.selectedMembers = [];
    $scope.setRepeat = false;

    $scope.processContent = function ($fileContent) {
        $scope.content = $fileContent;
    };

    this.openpage2 = function() {
      _this.page2 = true;
      _this.scrollPageDown();
    }

    this.openpage3 = function () {
      _this.page3 = true;
      _this.scrollPageDown();
    }

    this.closepage2 = function() {
      _this.page2 = false;
    }

    this.closepage3 = function() {
      _this.page3 = false;
    }

    this.close = function() {
      $state.go('dashboard.departments.department.tasksAdvanced', { departmentId: _this.department.id });
    }
	
    this.scrollPageDown = function() {
      setTimeout(() => {
          $scope.scrollDown();
      }, 300);
    }

    // Function to scrollDown
    $scope.scrollDown = function () {
		var container = document.getElementById('scrollContainer');
		container.scrollTop = container.scrollHeight;
    };

    this.getMembers = function (query) {
        var scope = {};

        if (query) {
            scope = {
                where: {
                    or: [{
                        email: {
                            regexp: '/^' + query + '/i'
                        }
                    }, {
                        firstName: {
                            regexp: '/' + query + '/i'
                        }
                    }, {
                        lastName: {
                            regexp: '/' + query + '/i'
                        }
                    }]
                }
            };
        }

        return Department.teams({
            id: $state.params.departmentId,
            filter: {
                include: {
                    relation: 'members',
                    scope: scope
                }
            }
        })
            .$promise
            .then(function (teams) {
                var members = teams.reduce(function (memberList, team) {
                    //we add the first team, easy peasy.
                    if (!memberList.length) {
                        memberList = memberList.concat(team.members);
                    }

                    //remaining teams, we check if the member is already on the list
                    team.members.forEach(function (member) {
                        for (var i = 0; i < memberList.length; i++) {
                            if (member.id === memberList[i].id) {
                                return;
                            }
                        }
                        //we return the list for next iteration
                        memberList.push(member);
                    });

                    return memberList;

                }, []);
                return members;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.exportRows = function () {
        _this.gridOptions.api.exportDataAsCsv({
            fileName: 'tareas.csv'
        });
    }

    this.showImportFile = function () {
        $uibModal.open({
            animation: true,
            controller: [                
                "$state"
                , 'Authentication',
                function ($state, Authentication) {
                    this.Authentication = Authentication;
                    $state.importTasks = {};
                    $state.go('dashboard.departments.department.tasksAdvanced.import1b');
                }
            ],
            templateUrl: "dashboard-tasks-advanced/importFileModal.html",
            controllerAs: "modalImport",
            size: "xlg",
            windowClass: "dialog",
            bindToController: true
        });
    };
};
